import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { restoreAuthState } from './redux/slices/authSlice';
import AppLayout from './components/Layout/AppLayout';
import Dashboard from './pages/Dashboards';
import Product from './pages/ProductManagement';
import Order from './pages/OrderManagement';
import Login from './pages/Login';
import './App.css';
import dayjs from 'dayjs';

const App = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  // 👇 Gọi restoreAuthState một lần khi app khởi động
  useEffect(() => {
    dispatch(restoreAuthState());
  }, [dispatch]);

  useEffect(() => {
    const today = dayjs().format('YYYY-MM-DD');
    const savedDate = localStorage.getItem('appDate');
    if (savedDate != today) {
      localStorage.clear();
      localStorage.setItem('appDate', today);
      window.location.reload();
      if (!localStorage.getItem('token')) {
        window.location.href = '/login';
      }
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="*"
          element={
            <AppLayout>
              <Routes>
                <Route path="*" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/product" element={<Product />} />
                <Route path="/order" element={<Order />} />
              </Routes>
            </AppLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;